import { all } from 'redux-saga/effects';
import empWatcher from './emp-document-saga';

export default function* rootSaga(action) {
	yield all([empWatcher(action)]);
}
